import axios from 'axios'
import store from '../store'
import router from '../router'
import hui from 'h_ui/dist/h_ui.min.js'
import Cookies from 'js-cookie'
import qs from 'qs'
import Vue from 'vue'

let _this = new Vue()
const httpFetch = axios.create({
    baseURL: LOCAL_CONFIG.API_HOME,
    headers: {
      // 'Authorization' : sessionStorage['token']
      'Content-Type': 'application/x-www-form-urlencoded'

    }
  }
)


httpFetch.interceptors.request.use(config => {
  config.method === 'post'
    ? config.data = qs.stringify({ ...config.data })
    : config.params = { ...config.params }
  config.headers['Authorization'] = sessionStorage['token']

  return config
}, error => {  //请求错误处理
  return Promise.reject(error)
})

httpFetch.interceptors.response.use(response => {
  let { status, data, config } = response
  if (status !== 200) {
    config.tips && _this.$hMessage.error(`接口${status}异常`)
    return Promise.reject(response)
  }
  if (response.request.responseType === 'blob') {
    download(response)
    return
  }

  let code = response.data['errcode']
  if (response.data && typeof response.data == 'string') {
    response.data = JSON.parse(response.data)
  }
  if (code == 0) {
    return response
  }
  let text = ''
  if (code == '200010' || code == '200011') {
    text = '登录信息已失效，请重新登录'
    hui.hMsgBox.warning({
      title: '重新登录',
      content: text,
      onOk: () => {
        store.dispatch('ReLogin')

      }
    })

  } else if (code == '200013') {
    text = '你无访问权限'
    hui.hMsgBox.warning({
      title: '提示',
      content: text,
      onOk: () => {
        // store.dispatch('ReLogin')
        window.location.href = window.location.href.split('#')[0] + '#/mainIndex'
      }
    })
  } else {
    return response
  }
}, error => {
  /*网络连接过程异常处理*/
  let { message, config } = error
  if (message == 'Network Error') message = '网络错误'
  if (message.includes('timeout')) message = '接口请求超时'
  if (message.includes('Request failed with status code')) {
    message = '接口' + message.substr(message.length - 3) + '异常'
  }
  config.tips && _this.$hMessage.error(message || '接口未知异常')
  return Promise.reject({
    errmsg: message
  })
})

// 下载文件
function download(res) {
  if (
    res.data.type !== 'application/json' ||
    res.headers['content-disposition'].includes('.xls')
  ) {
    /*if (!res.data.size) {
      _this.$hMessage.error('文件不存在')
      return
    }*/
    // let blob = new Blob([res.data], {type: 'application/vnd.ms-excel;charset=utf-8'})
    let href = URL.createObjectURL(res.data)
    let a = document.createElement('a')
    a.href = href
    let title = res.headers['content-disposition']
    a.download = decodeURIComponent(title.split('=')[1])
    // a.download = unescape(decodeURI((title).split('=')[1]))
    a.click()
    a = null
    URL.revokeObjectURL(href)
  } else {
    let reader = new FileReader()
    /*reader.addEventListener("loadend", function() {
        console.log(JSON.parse(reader.result));
    });*/
    reader.onload = (e) => {
      let data = JSON.parse(e.target.result)
      _this.$hMessage.error(data.errmsg || '未知异常')
    }
    reader.readAsText(res.data, ['utf-8'])
  }
}

export default httpFetch

let xhr = (
  url,
  method = 'get',
  params,
  {
    tips = true, //错误弹提示
    ...config
  } = {}
  //responseType:'blob' //下载
) => {
  let data = method.toLocaleLowerCase() === 'get' ? 'params' : 'data'
  return httpFetch({
    method,
    url,
    [data]: params,
    tips,
    ...config
  })
}
xhr.get = (url, ...values) => xhr(url, 'get', ...values)
xhr.post = (url, ...values) => xhr(url, 'post', ...values)
xhr.download = (url, params, config) =>
  xhr(url, 'get', params, { responseType: 'blob', ...config })
//请求方法
export { xhr }



// WEBPACK FOOTER //
// ./src/api/httpFetch.js